export default {
  toasts: {
    verification_pending: 'Twoja weryfikacja jest nadal w toku',
  },
};
